import { HttpContextToken } from '@angular/common/http';

export const CREATE = 'create';
export const NO_AUTH = new HttpContextToken<boolean>(() => false);
export const NO_CACHE = new HttpContextToken<boolean>(() => false);
export const UPDATE = 'update';

export enum BOOTSTATE {
  NONE = 1,
  SPIN,
  FAIL,
  DONE,
}
export type ModelType = typeof CREATE | typeof UPDATE;
export interface SessionTokens {
  access_token: string;
  refresh_token: string;
}
export * from './enrol';
export * from './user';
